import { Routes } from '@angular/router';
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('./modules/layout/layout.routes').then((m) => m.LAYOUT_ROUTES),
  },
  { path: '**', redirectTo: 'error/404' },
];
